exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".address-info[data-v-566acb14]{background:#f8f9fa;padding:15px;border-radius:8px;border-left:4px solid #28a745;box-shadow:2px 2px 8px rgba(0,0,0,.1);font-family:Arial,sans-serif;max-width:400px}.address-text[data-v-566acb14]{font-size:16px;font-weight:700;color:#333;margin-bottom:5px}.address-city[data-v-566acb14]{font-size:14px;color:#555;margin-bottom:10px}.address-dates[data-v-566acb14]{display:flex;flex-direction:column;font-size:14px;color:#666;margin-top:5px}.address-dates span[data-v-566acb14]{padding:3px 0}", ""]);

// exports
